import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-8">
      <div className="flex flex-col items-center text-center max-w-150">
        <img
          src="/images/util/404.png"
          alt="404 Not Found"
          className="w-full max-w-150 h-auto mb-8 animate-fadeIn"
        />
        <h1 className="text-4xl md:text-2xl font-bold text-neutral-900 mb-4">
          Page Not Found
        </h1>
        <p className="text-base md:text-sm text-neutral-500 mb-8 leading-relaxed">
          The page you're looking for doesn't exist. Please check the URL or
          return to the dashboard.
        </p>
        <button
          className="px-8 py-3 bg-primary !text-white font-semibold rounded-lg shadow-card hover:opacity-90 hover:shadow-card-hover transition-all cursor-pointer"
          onClick={() => navigate('/admin/dashboard')}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
